module.exports = __webpack_public_path__ + "static/img/pic1@2x.5e595e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_template/pic1@2x.png
// module id = 93er
// module chunks = 0